
/*
    Like the name says, this is the login page for the app, 
    which shows a username/password form
    
    The login method itself is passed in as a prop
*/

import React, { createRef } from "react";

// the display shifts these depending on whether we're showing the password as visible text or not
import Icon_Eye from "../Components/Icon_Eye";
import Icon_EyeSlash from "../Components/Icon_EyeSlash";

import { SSO_Login } from "../Requests/UserRequests";
import { getLocations } from "../Requests/UtilityRequests";

import BaseValues,{ setSSOToken } from "../Requests/BaseValues";

export default class LoginPage extends React.Component {

    state = {
        username: "",
        password: "",
        showPassword: false
    }

    constructor(){
        super();
        this.nameRef = createRef();
    }

    componentDidMount(){
        this.nameRef.current.focus();

        console.log("ATTEMPT THE SSO LOGIN... if not logged out", this.props.loggedOut);

        if(this.props.loggedOut){
            return;
        }

        setTimeout(() => {
            // attempt SSO login first
                SSO_Login(
                    this.SSO_Accept,
                    (res) => {console.error("Unsuccessful SSO Caught on Login Page", res)}
                );
        }, 10);
    }

    SSO_Accept = (token) => {
        const userString = token.account.name;

        // get the value that's between parentheses
        var regExp = /\(([^)]+)\)/;
        var matches = regExp.exec(userString);

        console.log("USER EXTRACTION MATCHES", matches);

        const userdata = {
            username: matches[1]
        };

        // const tokenWrapper = 
        // {
        //     data: token
        // };

        const tokenString = JSON.stringify(token);

        console.log("THE TOKENS");
        console.log("TOKEN INPUT", typeof token, token);
        console.log("TOKEN STRING", typeof tokenString, tokenString.length, tokenString);

        this.props.attemptLogin(userdata, tokenString);
    }

    getLocations = () => {
        getLocations()
        .then(res => {
            console.log("SSO GET LOCATIONS ON LOGIN", res);
        })
        .catch(error => console.error("GET LOCATIONS SSO ERROR", error));
    }

    runLogin = (evt) => {
        evt.preventDefault();
        console.log("LOGIN FORM", this.state);
        this.props.attemptLogin(this.state);
    }

    inputChange = (evt) => {
        this.setState({[evt.target.name]: evt.target.value});
    }

    toggleShowPassword = (evt) => {
        this.setState({showPassword: !this.state.showPassword});
    }

    render() {

        const text = "PCS Portal"

        return (
            <div className="login-page">
                <div className="title svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width={190} height={40} role="img" aria-labelledby="NJTLogoDesktopTitle" className="d-none d-md-inline d-print-none">
                        <title id="NJTLogoDesktopTitle">NJ TRANSIT Logo</title> 
                        {/* <g fill="#fff">
                            <path d="M47.493.557v3.428h-5.786v15.857h-4.028V3.985h-5.785V.557zM62.11 1.053a4.767 4.767 0 011.8 1.346 5.972 5.972 0 01.965 1.62 5.411 5.411 0 01.357 2.026 5.82 5.82 0 01-.686 2.7 3.845 3.845 0 01-2.264 1.875 3.539 3.539 0 011.849 1.52 6.463 6.463 0 01.544 3.019v1.3a9.672 9.672 0 00.108 1.8 1.612 1.612 0 00.749 1.1v.486h-4.378q-.186-.643-.265-1.037a9.407 9.407 0 01-.173-1.667l-.026-1.8a3.687 3.687 0 00-.633-2.467 3.2 3.2 0 00-2.277-.617h-3.905v7.586H49.89V.557h9.19a8.376 8.376 0 013.03.496zm-8.237 2.8v5.228h4.31a4.515 4.515 0 001.926-.317 2.2 2.2 0 001.136-2.191 2.47 2.47 0 00-1.1-2.377 3.918 3.918 0 00-1.852-.344zM74.6.557h4.544l6.78 19.285h-4.357l-1.271-3.986h-7.052l-1.31 3.986H67.74zm-.271 12h4.914l-2.42-7.591zM88.372.557h4.2l7.632 13.428V.557h3.729v19.285h-4L92.106 6.16v13.682h-3.734zM110.594 13.885a3.952 3.952 0 00.724 1.979 4.182 4.182 0 003.387 1.192 7.179 7.179 0 002.332-.314 2.242 2.242 0 001.7-2.239 1.654 1.654 0 00-.837-1.48 9.021 9.021 0 00-2.645-.9l-2.059-.457a13.058 13.058 0 01-4.2-1.478 4.683 4.683 0 01-1.964-4.17 5.553 5.553 0 011.895-4.3 8.043 8.043 0 015.564-1.713 8.492 8.492 0 015.228 1.615 5.75 5.75 0 012.27 4.685h-3.857a2.723 2.723 0 00-1.538-2.438 5.29 5.29 0 00-2.373-.477 4.514 4.514 0 00-2.519.622 1.967 1.967 0 00-.941 1.735 1.637 1.637 0 00.928 1.528 11.607 11.607 0 002.536.795l3.35.8a8.535 8.535 0 013.3 1.4 4.723 4.723 0 011.709 3.93 5.536 5.536 0 01-2.026 4.38 8.514 8.514 0 01-5.726 1.743 9.324 9.324 0 01-5.941-1.714 5.685 5.685 0 01-2.164-4.714zM129.152 19.842h-3.985V.557h3.985zM146.994.557v3.428h-5.785v15.857h-4.028V3.985h-5.786V.557z"></path>
                        </g>  */}
                        <g fill="#fff">
                            <path d="M17.95 17.268V.327h5.062v1c.007 5.732.005 11.463.026 17.2a5.208 5.208 0 01-1.131 3.4 3.776 3.776 0 01-4.569 1.083 10.1 10.1 0 01-4.124-3.408c-2.374-2.962-4.785-5.9-7.368-9.079v18.485H0v-.97V4.521a3.157 3.157 0 012.2-3.253 3.7 3.7 0 013.917 1.26C7.538 4.196 8.83 5.952 10.191 7.66q3.605 4.526 7.229 9.039c.111.14.244.265.53.569z"></path> 
                            <path d="M24.693.265h5.136v1.028c0 6.291-.036 12.582.012 18.872.036 4.629-3.77 8.71-8.744 9.631-4.2.777-7.573-.745-10.357-3.422a39.2 39.2 0 01-3.082-3.7 2.625 2.625 0 01-.2-.313c-.014-2.4 0-5.045 0-7.6 1.231 1.587 2.569 3.361 3.877 4.894a27.848 27.848 0 003.956 4.134c3.027 2.34 6.773 1.635 8.452-1.491a7.036 7.036 0 00.874-3.108c.094-5.918.066-11.836.079-17.755-.002-.368-.003-.734-.003-1.17z"></path>
                        </g>
                        
                        <style>
                            {
                                // ".heavy { font: bold 20px Arial;}"
                                ".heavy { font: bold 24px Arial;}"
                            }
                        </style>

                        <g fill="#fff">
                            {/* <text x="160" y="19" class="heavy">{text}</text> */}
                            <text x="44" y="18" className="heavy">{text}</text>
                        </g>
                    </svg>
                </div>
                <form>
                    <div className="login-form-grid">
                        <label htmlFor="login_username">Username</label>
                        <input 
                            id="login_username"
                            ref={this.nameRef}
                            type="text" 
                            name="username" 
                            value={this.state.username} 
                            onChange={this.inputChange} />
                        <label htmlFor="login_password">Password</label>
                        <div style={{display: "flex", alignItems:"center"}}>
                            <input 
                                id="login_password"
                                type={this.state.showPassword ? "text" : "password"}
                                name="password" 
                                value={this.state.password} 
                                onChange={this.inputChange} 
                                style={{padding: "4px", marginRight: "6px"}}
                            />
                            <div onClick={this.toggleShowPassword}>
                            {
                                this.state.showPassword
                                ? <Icon_EyeSlash />
                                : <Icon_Eye />
                            }
                            </div>
                        </div>
                        
                        <button className="option" onClick={this.runLogin}>Login</button>
                    </div>

                </form>
                {/* <button onClick={this.getLocations}>Get Locations</button> */}
            </div>
        )
    }
}
